import { useSearchParams } from "react-router-dom";

export default function UnsubscribeView() {
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status"); // "success" | "error" | null

  const containerStyle = {
    minHeight: "100vh",
    background: "var(--bg)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 24px",
  };

  const cardStyle = {
    maxWidth: 480,
    textAlign: "center",
    background: "var(--surface)",
    border: "1px solid var(--border)",
    borderRadius: "var(--radius)",
    padding: "48px 40px",
  };

  if (status === "error") {
    return (
      <div style={containerStyle}>
        <div style={cardStyle}>
          <div style={{ fontSize: 28, marginBottom: 16, color: "var(--red)" }}>✕</div>
          <h2 style={{ fontSize: 22, marginBottom: 12, color: "var(--text)", fontWeight: 600 }}>
            Something went wrong
          </h2>
          <p style={{ color: "var(--text-dim)", fontSize: 14, lineHeight: 1.7 }}>
            We couldn't process your unsubscribe request. The link may be invalid or expired.
          </p>
        </div>
      </div>
    );
  }

  if (status === "success") {
    return (
      <div style={containerStyle}>
        <div style={cardStyle}>
          <div style={{ fontSize: 28, marginBottom: 16, color: "var(--green)" }}>✓</div>
          <h2 style={{ fontSize: 22, marginBottom: 12, color: "var(--text)", fontWeight: 600 }}>
            You've been unsubscribed
          </h2>
          <p style={{ color: "var(--text-dim)", fontSize: 14, lineHeight: 1.7 }}>
            You will no longer receive marketing emails from us.
          </p>
          <p style={{ color: "var(--text-muted)", fontSize: 13, lineHeight: 1.7, marginTop: 16 }}>
            Changed your mind? You can re-subscribe anytime from your <a href="/account" style={{ color: "var(--amber)" }}>Account Settings</a>.
          </p>
        </div>
      </div>
    );
  }

  // No status param — someone navigated here directly
  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <h2 style={{ fontSize: 22, marginBottom: 12, color: "var(--text)", fontWeight: 600 }}>
          Unsubscribe
        </h2>
        <p style={{ color: "var(--text-dim)", fontSize: 14, lineHeight: 1.7 }}>
          Use the unsubscribe link in any marketing email to opt out, or manage your preferences in your <a href="/account" style={{ color: "var(--amber)" }}>Account Settings</a>.
        </p>
      </div>
    </div>
  );
}
